<template>
  <div>
    <b-container fluid>
      <b-row>
        <b-col cols="12" class="p-0">
          <TopBarMember class="mb-0 mb-sm-3" />
        </b-col>
      </b-row>
    </b-container>
    <b-container class="p-0 px-sm-0">
      <b-card
        header-bg-variant="dark"
        header-border-variant="dark"
        header-text-variant="white"
        header-tag="header"
        border-variant="dark"
        class="main-card"
      >
        <template #header class="card-header px-0">
          <router-link to="/">
            <i class="fas fa-chevron-left"></i> หน้าหลัก
          </router-link>
        </template>
        <b-row>
          <b-col>
            <h5>
              <i class="fas fa-dice"></i> {{getAppName}} CASINO
            </h5>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="text-center">
            <b-row class="mt-2" v-if="games.length > 0">
              <b-col
                  xs="12"
                  sm="12"
                  md="6"
                  lg="4"
                  xl="4"
                  class="px-2"
                  v-for="(game,index) in games"
                  v-bind:key="index"
                >
                <div class="col-sm-3"  @click="playGame(game.id)" style="cursor: pointer;">
                    <div class="card mb-4" style="width: 18rem;">
                      <img class="card-img-top rounded-top" :src="game.imageUrl" alt="placeholder" />
                        <div class="card-body">
                            <h5 class="card-title">{{game.name}}</h5>

                        </div>
                    </div>
                </div>
         
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-card>
    </b-container>
    <FooterIndex class="mt-3" />
  </div>
</template>

<script>
import { Component, Vue, Prop } from "vue-property-decorator";
import { mapGetters } from "vuex";

// Include Component
import TopBarMember from "@/components/TopBarMember.vue";
import FooterIndex from "@/components/Footer.vue";
import axios from "axios";
export default {
  name: 'Casino',
  props: ['page'],
  components: {
    TopBarMember,
    FooterIndex
  },
  data() {
    return {
      games: []
    };
  },  
  computed: {
    ...mapGetters({
      getAppName: "getAppName",
      getAccessToken: "getAccessToken",
      getUsername: "getUsername",
      getCashAmount: "getCashAmount",
      getLottoType: "getLottoType",
      getApiUrl: "getApiUrl",
    })
  },
  mounted() {
    this.getGames();
  },
  methods:{
    getGames() {
      axios.post("https://api.tripleclickapi.com/external/games",
        {

        },
        {
          headers: {
            "Content-Type": "application/json",
            "Authorization": "4dADAaD6e9bDC4C1950384C50168Fd1Be8a3B940D5C22f92412f96b91dF120D2",
          }
        } )
        .then(response => {
          this.games = response.data;
          console.log(response);
        });
    },
    playGame(gameId){
      axios.post("https://api.tripleclickapi.com/external/operators/init-session",
        {
          "operatorId": "9f8352ac-f0c9-4c2d-a5cc-b587042c6a2a",
          "userToken": this.getUsername,
          "gameId": gameId, 
          "poolId": "94d23bd9-bf02-404e-9320-4f8f46b1a0f4",
          "hrefBackUrl": "",
          "payOffSetting": {}, 
          "usePool": false
        },
        {
          headers: {
            "Content-Type": "application/json",
            "Authorization": "ec2963B8Cf447C16B5EB29c9F63FC4ce81850B2D1d859ba6e3fF373759DD57C0",
          }
        } )
        .then(response => {
          window.location.href = response.data.url;
        });
    }
  }
}
</script>

<style lang="scss" scoped>
.main-card {
  min-height: calc((100vh - 104px) - 49px);
}

.card-header {
  font-size: 90%;
  line-height: 90%;

  a {
    color: #bbbbbb;

    &:hover {
      color: #bd841b;
      text-decoration: none;
    }
  }
}

h5 {
  color: #bd841b;
  font-weight: bold;
}

.credit-balance {
  background-color: #d4edda !important;
  border-color: #c3e6cb;
  font-size: 30px;
  line-height: 40px;
  height: 48px;

  :focus {
    outline: none;
  }
}
</style>